import { Box } from "@mui/material"
import { PeriodSummary } from "routes/schedule/plugins/timing-summary/schedule-timing"
import { formatTime } from "lib/format-time"
import { convertPeriodLabelToFrequency } from "library/convert-period-label-to-frequency.mjs"

export function PeriodEntry({ results, totalMinutes, item }) {
    return (
        <Box p={2} pr={3}>
            <PeriodSummary
                title={item}
                number={formatTime(results[item]?.minutes ?? 0)}
                time={""}
                total={results[item]?.count ?? 0}
                Component={Box}
                frequency={convertPeriodLabelToFrequency(item)}
                percent={(100 * (results[item]?.minutes ?? 0)) / totalMinutes}
            />
        </Box>
    )
}
